import { defineMessages, isMessageWithProps } from './defineMessages';

export const intlHelpers = {
    defineMessages,
    isMessageWithProps,
};
